<template>
  <b-modal
    id="searchModal"
    ref="modal"
    title="送信一覧検索"
    hide-footer
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @hidden="hideModal"
    size="lg"
  >
    <form ref="form" @submit.prevent="handleSearch">
      <!-- 送信日 -->
      <div class="form-group row mb-3">
        <div class="col-sm-12">
          <div class="date-box">
            <label class="field-label-inline">送信日</label>
            <div class="d-flex align-items-center date-range-wrapper">
              <div class="date-input-wrapper">
                <span class="date-label" v-if="!fromSentDateModel">From</span>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  :calendar-button="false"
                  :typeable="false"
                  v-model="fromSentDateModel"
                  placeholder=""
                  class="date-picker-input"
                ></vuejs-datepicker>
              </div>
              <span class="date-separator">～</span>
              <div class="date-input-wrapper">
                <span class="date-label" v-if="!toSentDateModel">To</span>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  :calendar-button="false"
                  :typeable="false"
                  v-model="toSentDateModel"
                  placeholder=""
                  class="date-picker-input"
                ></vuejs-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 回答日 -->
      <div class="form-group row mb-3">
        <div class="col-sm-12">
          <div class="date-box">
            <label class="field-label-inline">回答日</label>
            <div class="d-flex align-items-center date-range-wrapper">
              <div class="date-input-wrapper">
                <span class="date-label" v-if="!fromResponseDateModel">From</span>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  :calendar-button="false"
                  :typeable="false"
                  v-model="fromResponseDateModel"
                  placeholder=""
                  class="date-picker-input"
                ></vuejs-datepicker>
              </div>
              <span class="date-separator">～</span>
              <div class="date-input-wrapper">
                <span class="date-label" v-if="!toResponseDateModel">To</span>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  :calendar-button="false"
                  :typeable="false"
                  v-model="toResponseDateModel"
                  placeholder=""
                  class="date-picker-input"
                ></vuejs-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 登録者の登録/更新日 -->
      <div class="form-group row mb-3">
        <div class="col-sm-12">
          <div class="date-box">
            <label class="field-label-inline">登録者の<br/>登録/更新日</label>
            <div class="d-flex align-items-center date-range-wrapper">
              <div class="date-input-wrapper">
                <span class="date-label" v-if="!fromDateModel">From</span>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  :calendar-button="false"
                  :typeable="false"
                  v-model="fromDateModel"
                  placeholder=""
                  class="date-picker-input"
                ></vuejs-datepicker>
              </div>
              <span class="date-separator">～</span>
              <div class="date-input-wrapper">
                <span class="date-label" v-if="!toDateModel">To</span>
                <vuejs-datepicker
                  format="yyyy-MM-dd"
                  clear-button-icon="fa fa-times"
                  :disabled-dates="disableFunction"
                  :clear-button="true"
                  :bootstrap-styling="true"
                  :calendar-button="false"
                  :typeable="false"
                  v-model="toDateModel"
                  placeholder=""
                  class="date-picker-input"
                ></vuejs-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- スカウト形式 -->
      <div class="form-group row mb-3">
        <label class="col-sm-3 col-form-label field-label">スカウト形式</label>
        <div class="col-sm-9">
          <div class="checkbox-group-vertical">
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="contact-面接案内"
                  value="面接案内"
                  class="form-check-input"
                  v-model="contactTypeModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="contact-面接案内" class="checkbox-label">面接案内</label>
              </div>
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="contact-カジュアル面談"
                  value="カジュアル面談"
                  class="form-check-input"
                  v-model="contactTypeModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="contact-カジュアル面談" class="checkbox-label">カジュアル面談</label>
              </div>
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="contact-応募案内"
                  value="応募案内"
                  class="form-check-input"
                  v-model="contactTypeModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="contact-応募案内" class="checkbox-label">応募案内</label>
              </div>
            </div>
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="contact-通知のみ"
                  value="通知のみ"
                  class="form-check-input"
                  v-model="contactTypeModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="contact-通知のみ" class="checkbox-label">通知のみ</label>
              </div>
            </div>
          </div>
          <div class="notification-note">
            ※通知のみは、求人添付および登録者からの回答受付はできません。
          </div>
        </div>
      </div>

      <!-- 回答内容 -->
      <div class="form-group row mb-3">
        <label class="col-sm-3 col-form-label field-label">回答内容</label>
        <div class="col-sm-9">
          <div class="checkbox-group-vertical">
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="response-面接参加"
                  value="面接参加"
                  class="form-check-input"
                  v-model="userResponseModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="response-面接参加" class="checkbox-label">面接参加</label>
              </div>
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="response-カジュアル面談"
                  value="カジュアル面談"
                  class="form-check-input"
                  v-model="userResponseModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="response-カジュアル面談" class="checkbox-label">カジュアル面談</label>
              </div>
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="response-選考応募"
                  value="選考応募"
                  class="form-check-input"
                  v-model="userResponseModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="response-選考応募" class="checkbox-label">選考応募</label>
              </div>
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="response-応募見合わせ"
                  value="応募見合わせ"
                  class="form-check-input"
                  v-model="userResponseModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="response-応募見合わせ" class="checkbox-label">応募見合わせ</label>
              </div>
            </div>
            <div class="checkbox-row">
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  id="response-通知のみ"
                  value="通知のみ"
                  class="form-check-input"
                  v-model="userResponseModel"
                />
                <span class="checkbox-spacer"></span>
                <label for="response-通知のみ" class="checkbox-label">通知のみ</label>
              </div>
            </div>
          </div>
          <div class="notification-note">
            ※通知のみは、求人添付および登録者からの回答受付はできません。
          </div>
        </div>
      </div>

      <!-- リスト名 -->
      <div class="form-group row mb-3">
        <label class="col-sm-3 col-form-label field-label">リスト名</label>
        <div class="col-sm-9 d-flex align-items-center">
          <a
            href="javascript:void(0)"
            class="selection-link"
            @click.stop="toggleConfirmationListDropdown"
          >
            + 選択
          </a>
        </div>
      </div>

      <!-- Checkbox List (shown below when expanded) -->
      <div v-show="showConfirmationListDropdown" class="form-group row mb-3">
        <div class="col-sm-3"></div>
        <div class="col-sm-9">
          <div class="confirmation-checkbox-container">
            <div 
              v-for="(list, index) in reviewLists" 
              :key="list._id || index"
              class="confirmation-checkbox-item"
            >
              <input
                type="checkbox"
                :id="'list-' + (list._id || index)"
                :value="list._id"
                v-model="selectedConfirmationLists"
                class="confirmation-checkbox"
              />
              <span class="spacer"></span>
              <label :for="'list-' + (list._id || index)" class="confirmation-label">
                {{ list.title }}
              </label>
            </div>
            <div v-if="!reviewLists || reviewLists.length === 0" style="padding: 10px 0; color: #999; font-size: 14px;">
              リストがありません
            </div>
          </div>
        </div>
      </div>

      <!-- スカウト求人 -->
      <div class="form-group row mb-3">
        <label class="col-sm-3 col-form-label field-label">スカウト求人</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control text-input"
            v-model="jobQueryModel"
            placeholder="複数キーワードの場合はスペース区切りで入力してください"
          />
        </div>
      </div>

      <!-- 差出人名 -->
      <div class="form-group row mb-3">
        <label class="col-sm-3 col-form-label field-label">差出人名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control text-input"
            v-model="senderModel"
            placeholder="複数キーワードの場合はスペース区切りで入力してください"
          />
        </div>
      </div>

    </form>
    <div class="modal-footer custom-footer justify-content-center mt-4">
      <button
        type="button"
        class="btn btn-cancel"
        data-dismiss="modal"
        @click="hideModal"
      >
        キャンセル
      </button>
      <button
        type="submit"
        id="download"
        class="btn btn-search"
        @click="handleSearch('submit')"
      >
        検索
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';
import vuejsDatepicker from 'vuejs-datepicker';
import ApiService from '../../../../service/apiService';
import Api from '../../../../config/api';

export default {
  name: 'ContactSearch',
  components: { datePicker, vuejsDatepicker },
  data() {
    return {
      fromDateModel: '',
      toDateModel: '',
      fromSentDateModel: '',
      toSentDateModel: '',
      fromResponseDateModel: '',
      toResponseDateModel: '',
      contactTypes: ['面接案内', 'カジュアル面談', '応募案内', '通知のみ'],
      responseTypes: ['面接参加', 'カジュアル面談', '選考応募', '通知のみ', '応募見合わせ'],

      // userResponseModel: [],
      contactTypeModel: [],
      jobQueryModel: '',
      senderModel: '',
      selectedConfirmationLists: [],
      showConfirmationListDropdown: false,
      reviewLists: [],
      disableFunction: {
        customPredictor(date) {
          if (date > new Date()) {
            return true;
          }
        },
      },
    };
  },
  computed: {
    ...mapState({
      sentSearchParams: ({ contact }) => contact.sentSearchParams,
    }),
    ...mapGetters({
      getClientStatus: 'getClientStatus',
      sentSearchParams: 'getSentSearchParams',
      loading: 'getLoading',
      getSentStatusModel: 'getSentStatusModel',
      getUserResponseModel: 'getUserResponseModel',
    }),
    statusModel: {
      get() {
        return this.getSentStatusModel;
      },
      set(value) {
        this.setSentStatusModel(value);
      },
    },
    userResponseModel: {
      get() {
        return this.getUserResponseModel;
      },
      set(value) {
        this.setUserResponseModel(value);
      },
    },
  },
  methods: {
    ...mapMutations([
      'setSentStatusModel',
      'setSentContacts',
      'setSentContactsPagination',
      'setSentSearchParams',
      'setLoading',
      'toggleSearchModal',
      'setUserResponseModel',
      'setSentPage',
    ]),
    ...mapActions(['loadSentContacts']),
    handleSearch() {
      // Handle search logic here
      this.$emit('search', this.searchQuery);
    },
    hideModal() {
      this.toggleSearchModal(false);
      this.$refs.modal.hide();
    },
    handleSearch() {
      const searchParams = this.buildParams(1);
      this.setSentSearchParams(searchParams);
      this.setSentPage(1);
      this.toggleSearchModal(false);
      this.$refs.modal.hide();
    },
    openConfirmationListModal() {
      // TODO: Implement modal to select confirmation request list
      // For now, just show an alert
      alert('確認依頼者リスト選択機能は実装中です');
    },
    toggleConfirmationListDropdown() {
      this.showConfirmationListDropdown = !this.showConfirmationListDropdown;
      // Reload the list when opening to get latest data
      if (this.showConfirmationListDropdown) {
        this.loadReviewLists();
      }
    },
    closeConfirmationListDropdown() {
      this.showConfirmationListDropdown = false;
    },
    handleDocumentClick(event) {
      // Close dropdown if clicking outside
      const dropdown = this.$el.querySelector('.checkbox-list');
      const link = this.$el.querySelector('.selection-link');
      
      if (dropdown && !dropdown.contains(event.target) && link && !link.contains(event.target)) {
        this.closeConfirmationListDropdown();
      }
    },
    async loadReviewLists() {
      try {
        const response = await ApiService.get(Api.endpoints.REVIEW_LISTS);
        
        // Try different possible response structures
        if (response.data && Array.isArray(response.data)) {
          this.reviewLists = response.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.reviewLists = response.data.data;
        } else if (response.data && response.data.reviewLists && Array.isArray(response.data.reviewLists)) {
          this.reviewLists = response.data.reviewLists;
        } else {
          this.reviewLists = [];
        }
      } catch (error) {
        console.error('Error loading review lists:', error);
        this.reviewLists = [];
      }
    },
    buildParams() {
      // console.log(this.statusModel);
      const params = {};
      params.registrationDateFrom = this.fromDateModel || null;
      params.registrationDateTo = this.toDateModel || null;
      params.sentDateFrom = this.fromSentDateModel || null;
      params.sentDateTo = this.toSentDateModel || null;
      params.responseDateFrom = this.fromResponseDateModel || null;
      params.responseDateTo = this.toResponseDateModel || null;
      params.contact_type = this.contactTypeModel || null;
      params.user_response = this.userResponseModel || null;
      params.jobQuery = this.jobQueryModel || null;
      params.sender = this.senderModel || null;
      params.confirmationList = this.selectedConfirmationLists.length > 0 ? this.selectedConfirmationLists : null;
      params.status = this.statusModel || null;
      params.page = 1;
      
      return params;
    },
    prepopulateModels() {
      this.fromDateModel = this.sentSearchParams.registrationDateFrom
        ? this.sentSearchParams.registrationDateFrom
        : this.fromDateModel;
      this.toDateModel = this.sentSearchParams.registrationDateTo
        ? this.sentSearchParams.registrationDateTo
        : this.toDateModel;
      this.fromSentDateModel = this.sentSearchParams.sentDateFrom
        ? this.sentSearchParams.sentDateFrom
        : this.fromSentDateModel;
      this.toSentDateModel = this.sentSearchParams.sentDateTo
        ? this.sentSearchParams.sentDateTo
        : this.toSentDateModel;
      this.fromResponseDateModel = this.sentSearchParams.responseDateFrom
        ? this.sentSearchParams.responseDateFrom
        : this.fromResponseDateModel;
      this.toResponseDateModel = this.sentSearchParams.responseDateTo
        ? this.sentSearchParams.responseDateTo
        : this.toResponseDateModel;
      this.contactTypeModel = this.sentSearchParams.contact_type
        ? this.sentSearchParams.contact_type
        : this.contactTypeModel;
      // this.userResponseModel = this.sentSearchParams.user_response ? this.sentSearchParams.user_response : this.userResponseModel;
      this.jobQueryModel = this.sentSearchParams.jobQuery
        ? this.sentSearchParams.jobQuery
        : this.jobQueryModel;
      this.senderModel = this.sentSearchParams.sender
        ? this.sentSearchParams.sender
        : this.senderModel;
      this.selectedConfirmationLists = this.sentSearchParams.confirmationList
        ? this.sentSearchParams.confirmationList
        : this.selectedConfirmationLists;
      // this.statusModel = this.sentSearchParams.status ? this.sentSearchParams.status : this.statusModel;
    },
  },
  watch: {
    // Reload review lists when modal is shown to get latest data
    '$refs.modal': {
      handler() {
        if (this.$refs.modal && this.$refs.modal.isVisible) {
          this.loadReviewLists();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$refs.modal.show();
    this.prepopulateModels();
    this.loadReviewLists();
    
    // Add click listener to close dropdown when clicking outside
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // Remove click listener when component is destroyed
    document.removeEventListener('click', this.handleDocumentClick);
  },
};
</script>

<style scoped>
>>> .modal-header {
  border-bottom: none !important;
}

>>> .modal-lg {
  max-width: 800px !important;
}

>>> .modal-body {
  padding: 20px 40px !important;
}

.form-group {
  margin-bottom: 20px !important;
  padding-bottom: 0px;
}

.form-group:last-of-type {
  border-bottom: none;
}

.field-label {
  color: #3c3c3c !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  padding-top: 8px !important;
  text-align: left !important;
  line-height: 1.4 !important;
}

.field-label-inline {
  color: #3c3c3c !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  display: inline-block;
  margin-right: 20px;
  min-width: 150px;
}

/* Date picker styles */
.date-box {
  border: 1px solid #d0d0d0;
  padding: 25px 30px;
  display: flex;
  align-items: center;
  min-height: 80px;
}

.date-range-wrapper {
  gap: 10px;
}

.date-input-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 200px;
  position: relative;
  min-height: 30px;
  overflow: visible;
}

.date-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 0px;
  display: block;
  position: absolute;
  bottom: 8px;
  left: 0;
  z-index: 1;
  background-color: transparent;
  pointer-events: none;
}

.date-picker-input {
  flex: 1;
  position: relative;
}

>>> .date-picker-input .vdp-datepicker {
  position: relative;
}

>>> .date-picker-input input {
  width: 100% !important;
  padding: 0px !important;
  padding-right: 30px !important;
  font-size: 14px !important;
  border: none !important;
  border-bottom: 1px solid #d0d0d0 !important;
  border-radius: 0px !important;
  background-color: transparent !important;
  line-height: 1.5 !important;
  height: auto !important;
  min-height: 24px !important;
}

>>> .date-picker-input .vdp-datepicker__clear-button {
  position: absolute !important;
  right: 5px !important;
  top: 0px !important;
  transform: none !important;
  font-size: 16px !important;
  line-height: 24px !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0px 4px !important;
  cursor: pointer !important;
  color: #999 !important;
  z-index: 10 !important;
  width: 20px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

>>> .date-picker-input .vdp-datepicker__clear-button:hover {
  color: #333 !important;
  background-color: transparent !important;
}

>>> .date-picker-input input:focus {
  outline: none !important;
  border-bottom: 1px solid #006c6b !important;
}

>>> .date-picker-input input::placeholder {
  color: #999 !important;
  font-size: 14px !important;
}

/* Fix calendar navigation */
>>> .vdp-datepicker__calendar {
  z-index: 1000 !important;
}

>>> .vdp-datepicker__calendar header {
  pointer-events: auto !important;
}

>>> .vdp-datepicker__calendar header span {
  pointer-events: auto !important;
  cursor: pointer !important;
}

>>> .vdp-datepicker__calendar .prev,
>>> .vdp-datepicker__calendar .next {
  pointer-events: auto !important;
  cursor: pointer !important;
}

>>> .vdp-datepicker__calendar .prev:after,
>>> .vdp-datepicker__calendar .next:after {
  pointer-events: auto !important;
}

.date-separator {
  color: #3c3c3c;
  font-size: 14px;
  padding: 0 5px;
}

/* Checkbox styles */
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 30px;
  margin-bottom: 8px;
}

.checkbox-group-vertical {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.checkbox-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 30px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0px;
  min-height: 20px;
}

.checkbox-spacer {
  width: 8px;
  display: inline-block;
}

.form-check-input {
  margin: 0 !important;
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  top: 0px;
}

.checkbox-label {
  color: #3c3c3c !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  margin: 0 !important;
  cursor: pointer;
  white-space: nowrap;
  line-height: 16px !important;
  display: inline-block;
  user-select: none;
}

.notification-note {
  font-size: 11px;
  color: #787878;
  margin-top: 4px;
  line-height: 1.3;
}

/* Button styles */
.selection-link {
  color: #3c3c3c !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-decoration: none !important;
  cursor: pointer !important;
  display: inline-block;
}

.selection-link:hover {
  text-decoration: underline !important;
  color: #3c3c3c !important;
}

.selected-list-info {
  font-size: 14px;
  color: #3c3c3c;
  padding: 8px 0;
}

/* Text input styles */
.text-input {
  width: 100% !important;
  max-width: 500px !important;
  padding: 6px 12px !important;
  font-size: 14px !important;
  border: 1px solid #d0d0d0 !important;
  border-radius: 0px !important;
}

.text-input::placeholder {
  color: #999 !important;
  font-size: 14px !important;
}

/* Footer buttons */
.custom-footer {
  border-top: none !important;
  padding: 20px 40px !important;
}

.btn-cancel {
  background-color: #808080 !important;
  color: #fff !important;
  padding: 10px 40px !important;
  font-size: 14px !important;
  border: none !important;
  border-radius: 4px !important;
  margin-right: 15px !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-cancel:hover {
  background-color: #666 !important;
}

.btn-search {
  background-color: #006c6b !important;
  color: #fff !important;
  padding: 10px 40px !important;
  font-size: 14px !important;
  border: none !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-search:hover {
  background-color: #005555 !important;
}

/* Confirmation List Checkboxes */
.confirmation-checkbox-container {
  margin-top: 10px;
  padding: 10px 0;
}

.confirmation-checkbox-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.confirmation-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.confirmation-checkbox-item .spacer {
  width: 10px;
  flex-shrink: 0;
}

.confirmation-label {
  font-size: 14px;
  color: #000000;
  font-weight: 700;
  cursor: pointer;
  line-height: 16px;
  display: inline-block;
  user-select: none;
  margin: 0;
}
</style>
